// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ee28ba8e","455":"ee1956eb","977":"f0e070bb"}[chunkId] + ".chunk.js";
};